import type {FC} from "react";

import type {IconProps} from "./types";

const FourOThreeIcon: FC<IconProps> = (props) => {
	return (
		<svg
			width={256}
			height={256}
			viewBox="0 0 256 256"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#prefix__clip0_1509_19193)">
				<path
					d="M128 256c70.692 0 128-57.308 128-128C256 57.308 198.692 0 128 0 57.308 0 0 57.307 0 128c0 70.692 57.307 128 128 128z"
					fill="#F4F4F4"
				/>
				<rect x={36} y={58} width={184} height={140} rx={8} fill="#CBC5C2" />
				<path
					d="M47.906 74a4 4 0 100-8 4 4 0 000 8zM59.906 74a4 4 0 100-8 4 4 0 000 8zM71.906 74a4 4 0 100-8 4 4 0 000 8z"
					fill="#0C5850"
				/>
				<path
					d="M212 72c0 1.1-.975 2-2.167 2H84.167C82.975 74 82 73.1 82 72v-4c0-1.1.975-2 2.167-2h125.666c1.192 0 2.167.9 2.167 2v4zM212 186c0 2.2-1.8 4-4 4H48c-2.2 0-4-1.8-4-4V86c0-2.2 1.8-4 4-4h160c2.2 0 4 1.8 4 4v100z"
					fill="#F5F5F5"
				/>
				<path
					d="M153.118 177H103.88c-3.242 0-5.88-2.644-5.88-5.892v-38.214c0-3.248 2.638-5.894 5.88-5.894h49.24c3.241 0 5.88 2.644 5.88 5.894v38.212c-.002 3.25-2.639 5.894-5.882 5.894z"
					fill="#F5F5F5"
				/>
				<path
					d="M150.529 128h-45.515l-.01-1.496c-.002-.075-.004-.122-.004-.167 0-6.365 0-14.287 2.951-20.738C111.472 97.902 118.541 94 128.963 94c10.028 0 16.829 3.91 20.212 11.621C152 112.064 152 119.978 152 126.339c0 .047-.002.092-.004.139l-.01 1.495-1.457.027z"
					fill="#F5F5F5"
				/>
				<path
					d="M154.732 179h-52.466C98.81 179 96 176.17 96 172.692v-40.908c0-3.478 2.81-6.31 6.266-6.31h52.468c3.454 0 6.266 2.83 6.266 6.31v40.906c-.002 3.48-2.812 6.31-6.268 6.31zm-52.466-50.37c-1.727 0-3.132 1.415-3.132 3.154v40.906c0 1.739 1.405 3.154 3.132 3.154h52.468c1.727 0 3.132-1.415 3.132-3.154v-40.906c0-1.739-1.405-3.154-3.132-3.154h-52.468v0z"
					fill="#E9E9E9"
					stroke="#E9E9E9"
				/>
				<path
					d="M151.857 128.63h-48.604l-.01-1.567c-.003-.08-.005-.129-.005-.176 0-6.67 0-14.972 3.151-21.732C110.149 97.089 117.699 93 128.827 93c10.71 0 17.972 4.097 21.585 12.178 3.017 6.752 3.017 15.045 3.017 21.711 0 .049-.003.096-.005.146l-.01 1.567-1.557.028zm-45.485-3.154h43.923c-.028-12.83-.782-29.322-21.468-29.322-21.652 0-22.427 16.513-22.455 29.322z"
					fill="#E9E9E9"
					stroke="#E9E9E9"
				/>
				<path
					d="M131.54 150.915v-9.438a2.75 2.75 0 00-2.74-2.759 2.749 2.749 0 00-2.74 2.759v9.234a6.366 6.366 0 00-3.794 5.832c0 3.516 2.829 6.366 6.321 6.366 3.491 0 6.321-2.85 6.321-6.366a6.356 6.356 0 00-3.368-5.628z"
					fill="#E9E9E9"
				/>
				<path
					d="M89.41 145.886v-4.843l12.145-19.134h4.176v6.705h-2.472l-7.656 12.116v.227h17.259v4.929H89.41zM103.373 151v-6.591l.114-2.145v-20.355h5.767V151h-5.881zm24.993.639c-2.443-.009-4.546-.611-6.307-1.804-1.752-1.193-3.101-2.921-4.048-5.184-.938-2.264-1.402-4.986-1.392-8.168 0-3.172.468-5.876 1.406-8.111.947-2.235 2.296-3.935 4.048-5.099 1.762-1.175 3.859-1.762 6.293-1.762 2.433 0 4.526.587 6.278 1.762 1.762 1.174 3.116 2.879 4.063 5.113.947 2.226 1.415 4.925 1.406 8.097 0 3.191-.474 5.919-1.421 8.182-.937 2.263-2.282 3.991-4.034 5.184-1.752 1.194-3.849 1.79-6.292 1.79zm0-5.099c1.666 0 2.997-.838 3.991-2.514.995-1.677 1.487-4.191 1.478-7.543 0-2.206-.228-4.044-.682-5.511-.445-1.468-1.08-2.571-1.904-3.31-.814-.739-1.775-1.108-2.883-1.108-1.657 0-2.983.829-3.978 2.486-.994 1.657-1.496 4.138-1.505 7.443 0 2.235.222 4.1.667 5.597.455 1.486 1.094 2.604 1.918 3.352a4.206 4.206 0 002.898 1.108zm26.885 4.858c-2.121 0-4.01-.365-5.667-1.094-1.648-.739-2.95-1.752-3.906-3.04-.947-1.297-1.435-2.793-1.464-4.488h6.194c.038.71.27 1.335.696 1.875.435.53 1.013.942 1.733 1.235.719.294 1.529.441 2.429.441.937 0 1.766-.166 2.485-.497.72-.332 1.284-.791 1.691-1.378.407-.587.611-1.265.611-2.032 0-.776-.218-1.463-.654-2.059-.426-.606-1.042-1.08-1.846-1.421-.796-.341-1.743-.511-2.841-.511h-2.713v-4.517h2.713c.928 0 1.747-.161 2.457-.483.72-.322 1.278-.767 1.676-1.335.398-.578.597-1.25.597-2.017 0-.729-.175-1.369-.526-1.918a3.473 3.473 0 00-1.449-1.307c-.615-.312-1.335-.468-2.159-.468-.833 0-1.595.151-2.287.454-.691.294-1.245.715-1.662 1.264-.416.55-.639 1.193-.667 1.932h-5.895c.028-1.676.507-3.153 1.435-4.432.928-1.278 2.178-2.277 3.75-2.997 1.581-.729 3.366-1.094 5.355-1.094 2.007 0 3.764.365 5.27 1.094 1.505.729 2.675 1.714 3.508 2.955.843 1.231 1.26 2.613 1.25 4.147.01 1.629-.497 2.988-1.52 4.077-1.013 1.089-2.334 1.78-3.963 2.074v.227c2.14.275 3.769 1.018 4.886 2.23 1.127 1.203 1.686 2.709 1.677 4.517.009 1.658-.469 3.13-1.435 4.418-.956 1.288-2.278 2.301-3.963 3.04-1.686.738-3.618 1.108-5.796 1.108z"
					fill="#0C5850"
				/>
			</g>
			<defs>
				<clipPath id="prefix__clip0_1509_19193">
					<path fill="#fff" d="M0 0h256v256H0z" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default FourOThreeIcon;
